import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { CustomerHeaderMenuItemType } from './CustomerHeaderMenuItemType.csharp';
import { CustomerHeaderMenuItemViewModel } from './CustomerHeaderMenuItemViewModel.csharp';
import { CustomerHeaderMenuViewModel } from './CustomerHeaderMenuViewModel.csharp';
import { CustomerHeaderViewModel } from './CustomerHeaderViewModel.csharp';

interface CustomerHeaderProps {
    model: CustomerHeaderViewModel;
}

export default class CustomerHeader extends React.Component<CustomerHeaderProps> {
    constructor(props: CustomerHeaderProps) {
        super(props);
    }

    render() {
        const {
            props: {
                model: { userInformation, menu, showWelcomeMessage, logoutUrl, customerSupportUrl }
            }
        } = this;

        function renderMenu(menu: CustomerHeaderMenuViewModel) {
            return menu.items.map((item) => {
                return item.isClickable ? renderLinkMenuItem(item) : renderMenuItem(item);
            });
        }

        function renderLinkMenuItem(item: CustomerHeaderMenuItemViewModel) {
            return (
                <a href={item.url} className="CustomerHeader__Link" key={CustomerHeaderMenuItemType[item.type]}>
                    {renderMenuItem(item)}
                </a>
            );
        }

        function renderMenuItem(item: CustomerHeaderMenuItemViewModel) {
            return (
                <div
                    key={CustomerHeaderMenuItemType[item.type]}
                    className={classNames('CustomerHeader__Tile', item.isActive && 'CustomerHeader__Tile--Active', getIcon(item.type))}
                >
                    <span className="CustomerHeader__TileName">{item.name}</span>
                </div>
            );
        }

        function getIcon(type: CustomerHeaderMenuItemType) {
            return 'CustomerHeader__Tile--' + CustomerHeaderMenuItemType[type];
        }

        return (
            <>
                {<div className="CustomerHeader__Title">{menu.items.filter((x) => x.isActive)[0]?.name}</div>}
                <div className="CustomerHeader__TilesContainer">{renderMenu(menu)}</div>
                {showWelcomeMessage && (
                    <div className="CustomerHeader__Wrapper">
                        <h1 className="CustomerHeader__Heading">
                            {getTranslation(keys['userProfile.welcome'])} {userInformation.firstName} {userInformation.lastName}
                        </h1>
                        <p className="CustomerHeader__Description">
                            {getTranslation(keys['userProfile.loggedIn'])} <a href={logoutUrl}>{getTranslation(keys['userProfile.logOut'])}</a>.
                            <br />
                        </p>
                        <p className="CustomerHeader__Description">
                            {getTranslation(keys['userProfile.contactCustomerService'])}{' '}
                            <a href={customerSupportUrl}>{getTranslation(keys['userProfile.customerService'])}</a>.
                        </p>
                    </div>
                )}
            </>
        );
    }
}
